import { Spinner } from '@telefonica/mistica';
import React, { useEffect } from 'react';
import { isIOS } from 'react-device-detect';
import Stopper from '../../../components/Stopper';
import { managementEnvironment } from '../../../utils/dataTransformation/environments';

const LoginApp: React.FC = () => {
    const loginDisabled = managementEnvironment().REACT_APP_STOPPER_LOGIN_DISABLED;

    useEffect(() => {
        if (!loginDisabled) {
            // parametres recived from the app
            const url_params = window.location.search;
            window.location.href = `${process.env.REACT_APP_LOGIN_URL_APP}${url_params}`;
        }
    }, []);

    if (loginDisabled) {
        return <Stopper></Stopper>;
    }

    return (
        <>
            {isIOS && (
                <div className='c-spinner'>
                    <Spinner size={24} />
                    <span className='c-spinner-overlay'></span>
                </div>
            )}
        </>
    );
};

export default LoginApp;
